import React from 'react';
import { Link } from 'react-router-dom';
import CategoryCarousel from '../components/CategoryCarousel';
import { 
  photoVideographyImages,
  prePostWeddingImages,
  fashionShootImages,
  corporateEventsImages,
  babyShootsImages,
  adsImages,
  podcastImages,
  filmMakingImages
} from '../data/images';

const Home = () => {
  const videoTitle = "Professional Photography Excellence";

  return (
    <div className="home-page">
      <section className="hero">
        <div className="hero-video-container">
          {/* Fallback background */}
          <div className="hero-fallback-bg"></div>
          
          <video 
            className="hero-video"
            autoPlay
            muted 
            loop 
            playsInline
            preload="auto"
            webkit-playsinline="true"
            onLoadStart={() => console.log('Video loading started')}
            onCanPlay={() => console.log('Video can play')}
            onPlay={() => console.log('Video started playing')}
            onPause={() => console.log('Video paused')}
            onError={(e) => console.error('Video error:', e)}
          >
            <source src="/video/video-2.webm" type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>{videoTitle}</h1>
          <p>
            Professional photography and videography services including pre/post weddings, fashion shoots, 
            corporate events, baby shoots, ads, podcast, and film making. Serving all over India, US, and UK.
          </p>
        </div>
        
      </section>

      
      {/* Category Carousels Section */}
      <section className="categories-section">
        <div className="carousels-full-width">
          
          {/* Photography & Videography */}
          <div className="category-section">
            <div className="category-section-header">
              <CategoryCarousel 
                title="Photography & Videography"
                images={photoVideographyImages}
                category="photo-videography"
              />
              <Link to="/photo-videography" className="view-btn-top-right">
                View All
              </Link>
            </div>
          </div>

          {/* Pre & Post Wedding */}
          <div className="category-section">
            <div className="category-section-header">
              <CategoryCarousel 
                title="Pre & Post Wedding"
                images={prePostWeddingImages}
                category="pre-post-wedding"
              />
              <Link to="/pre-post-wedding" className="view-btn-top-right">
                View All
              </Link>
            </div>
          </div>

          {/* Fashion Shoots */}
          <div className="category-section">
            <div className="category-section-header">
              <CategoryCarousel 
                title="Fashion Shoots"
                images={fashionShootImages}
                category="fashion-shoot"
              />
              <Link to="/fashion-shoot" className="view-btn-top-right">
                View All
              </Link>
            </div>
          </div>

          {/* Corporate Events */}
          <div className="category-section">
            <div className="category-section-header">
              <CategoryCarousel 
                title="Corporate Events"
                images={corporateEventsImages}
                category="corporate-events"
              />
              <Link to="/corporate-events" className="view-btn-top-right">
                View All
              </Link>
            </div>
          </div>

          {/* Baby Shoots */}
          <div className="category-section">
            <div className="category-section-header">
              <CategoryCarousel 
                title="Baby Shoots"
                images={babyShootsImages}
                category="baby-shoots"
              />
              <Link to="/baby-shoots" className="view-btn-top-right">
                View All
              </Link>
            </div>
          </div>

          {/* Ads */}
          <div className="category-section">
            <div className="category-section-header">
              <CategoryCarousel 
                title="Advertising Photography"
                images={adsImages}
                category="ads"
              />
              <Link to="/ads" className="view-btn-top-right">
                View All
              </Link>
            </div>
          </div>

          {/* Podcast */}
          <div className="category-section">
            <div className="category-section-header">
              <CategoryCarousel 
                title="Podcast Production"
                images={podcastImages}
                category="podcast"
              />
              <Link to="/podcast" className="view-btn-top-right">
                View All
              </Link>
            </div>
          </div>

          {/* Film Making */}
          <div className="category-section">
            <div className="category-section-header">
              <CategoryCarousel 
                title="Film Making"
                images={filmMakingImages}
                category="film-making"
              />
              <Link to="/film-making" className="view-btn-top-right">
                View All
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
